import { render } from "./ThreeRandselEdge.vue?vue&type=template&id=c85745a4&ts=true"
import script from "./ThreeRandselEdge.vue?vue&type=script&lang=ts"
export * from "./ThreeRandselEdge.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__